import React, { useRef } from "react";
import { postImg } from "service/api/blog";
import { ReactComponent as ImgIcon } from "assets/common/input/imgIcon.svg";
import responseCodeConstant from "service/constant/responseCodeConstant";

interface Props {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  name: string;
}

export function ImgInput({ data, setData, name }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files![0]) {
      const formData = new FormData();
      formData.append("image", e.target.files![0]);
      const imgRes = await postImg(formData);
      if (imgRes.status === responseCodeConstant.SUCCESS.ok) {
        setData((prev: any) => ({
          ...prev,
          [name]: imgRes.data.data.src,
        }));
      }
    }
  };

  const handleAddBtn = () => {
    inputRef.current?.click();
  };

  return (
    <div className="w-full">
      <input
        className="hidden"
        id="fileInput"
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={handleInputChange}
      />
      {data[name] ? (
        <div className="flex h-[232px] w-full flex-col items-center justify-center gap-[14px] rounded-[8px] border-[1px] border-dashed border-gray-2 bg-[#fafafa]">
          <div className="relative w-fit">
            <img
              src={data[name]}
              alt="banner"
              className="max-h-[167px] max-w-[511px] cursor-pointer"
              onClick={handleAddBtn}
            />
          </div>
        </div>
      ) : (
        <div
          className="flex h-[232px] w-full cursor-pointer flex-col items-center justify-center gap-[14px] rounded-[8px] border-[1px] border-dashed border-gray-2 bg-[#fafafa]"
          onClick={handleAddBtn}
        >
          <ImgIcon />
          <p className="m-0 text-M3 text-gray-3">이미지를 업로드해주세요.</p>
        </div>
      )}
    </div>
  );
}
